import { useFlags } from 'launchdarkly-react-client-sdk';
import RenderLogPanelContent from './RenderLogPanelContent';

/**
 * Flag gate for the render debug panel. The instrumentation lives in RenderLogPanelContent, which
 * only mounts when the flag is on — so with the flag off nothing hooks the viewers and the tool
 * cannot skew the render behaviour it exists to measure.
 */
const RenderLogPanel = () => {
  const { showWebviewerDebugPanel } = useFlags();

  if (!showWebviewerDebugPanel) return null;

  return <RenderLogPanelContent />;
};

export default RenderLogPanel;
